// Replace the support email and refund policy page before publishing.
export const siteConfig = {
  productName: 'Pool Care Made Simple',
  price: '$33',
  checkoutUrl: 'https://pool-master.impultienda.ar/checkout',
  metaPixelId: '28236724749285303',
  supportEmail: 'support@yourdomain.com',
  refundPolicyUrl: '#refund-policy',
};

export const images = {
  bundleMockup:
    'https://cdn.magicpatterns.com/uploads/bnZDFmxdYc4SfS6F1g346f/Imagen_de_ChatGPT_26_sept_2026,_01_35_22_p.m..png',
  methodSpread:
    'https://cdn.magicpatterns.com/patterns/generated-images/546aea74-f925-452d-932c-9ece9002374f.jpg',
};
